import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { VirtualTableListingStateLess } from '../../../TwinTable/VirtualTableListing'
import { CustomRenderDate } from '../../../TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../TwinTable/VirtualTableListing/Subcomponents/types'
import { TaskModelType } from '@teinor/erp/types/company/task'
import TwinIcon from '../../../TwinIcon'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons'
import { changeBottomNavAppElement } from '../../../../utils/reducers/reduxDispatch'
import { CustomRenderTaskCustomerAndProject, CustomRenderTaskType } from '../../../../specificComponents/Task/TaskScreenTable/Subcomponents'


interface DSBAllTasksTableOverdueProps extends TableAllTasksOverdueProps {
    title: string
}

const DSBAllTasksOverdueTable: React.FC<DSBAllTasksTableOverdueProps> = ({title, yesterdayEnd}) => {
    return (
        <div className='flex flex-auto flex-col tce_employee_holidays_calendar'>
            <h3 className='pb-15'>{title}</h3>
            <TableAllTasksOverdue yesterdayEnd={yesterdayEnd}/>
        </div>
    )
}

interface TableAllTasksOverdueProps extends TableAllTasksOverdueLogicProps {

}

const TableAllTasksOverdue: React.FC<TableAllTasksOverdueProps> = ({yesterdayEnd}) => {
    const { t } = useTwinTranslation()
    const { data, handleOpenTask } = useTableAllTasksOverdueLogic({yesterdayEnd})
    const columns: ColumnTableSchema<TaskModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
        },
        {
            id: 'CustomerId',
            dataKey: 'CustomerId',
            label: t('customer', 'Cliente'),
            customRender: (_parameterValue, allRowData) => <CustomRenderTaskCustomerAndProject allRowData={allRowData} id={'main'} />,
        },
        {
            id: 'start_date',
            dataKey: 'end_date',
            label: t('from', 'Desde'),
            customRender: (parameterValue) => <CustomRenderDate value={parameterValue} />,
        },
        {
            id: 'end_date',
            dataKey: 'end_date',
            label: t('to', 'Hasta'),
            customRender: (parameterValue) => <CustomRenderDate value={parameterValue} />,
        },
        {
            id: 'TaskTypeId',
            dataKey: 'TaskType',
            label: '',
            simpleLabel: t('TaskType', 'Tipo de tarea'),
            customRender: (parameterValue) => <CustomRenderTaskType allRowData={parameterValue as {}} />,
            width: 40
        },
        {
            id: 'id',
            dataKey: 'id',
            label: '',
            customRender: (parameterValue) => <TwinIcon icon={faChevronRight} onClick={() => handleOpenTask(parseInt(String(parameterValue)))} className='cursor-pointer hover:text-green-43' size='lg' />,
            width: 50
        }
    ]

    return (
        <div className='flex-auto'>
            <VirtualTableListingStateLess tableData={data} rowHeight={48} headerHeight={48} name='DSBAllTasksTableDashboard' columns={columns} setSelectedColumnsAndFilters={() => { }} updateEmployeeParameter={false} />
        </div>
    )
}

interface TableAllTasksOverdueLogicProps {
    yesterdayEnd: Date
}

const useTableAllTasksOverdueLogic = ({ yesterdayEnd }: TableAllTasksOverdueLogicProps) => {
    const [data, setData] = useState<TaskModelType[] | null>(null)
    
    const handleOpenTask = useCallback(async(id: number) => {
        await changeBottomNavAppElement({ type: 'taskModal', key: 'taskModal-' + id, extraData: { id, opened: true } })
    }, [])

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/task/getAllTaskForCalendarSimple', {
            start_date: '1990-01-01',
            end_date: yesterdayEnd,
            whereToParse: { finished: 1 }
        })
        if (result) {
            setData(result)
        }
    }, [setData, yesterdayEnd])
    useEffect(() => {
        getData()
    }, [getData])

    return { data, handleOpenTask }
}

export default DSBAllTasksOverdueTable